import type { ProductsQueryResponse } from '../../types/Product'

export function verifyProductInStock(node?: ProductsQueryResponse['node']) {
  return (
    node?.offers?.offers?.some(
      ({ availability }) => availability === 'https://schema.org/InStock'
    ) && node.customOffers?.listPriceCustom > 0
  )
}
